<template>
    <div class="shop__material" :class="{ 'shop__material--selected': isSelected, 'shop__material--selectable': IsPickable }" @click="selectMaterial">
        <div class="shop__material-block-desc" :class="ColumnCssClass">
            <div class="shop__material-icon"><img :src="material.iconUrl" width="100" /></div>
            <div class="shop__material-name" v-html="migrolFormatText(material.name)"></div>
            <div class="shop__material-description" v-html="material.description"></div>
        </div>
        <div class="shop__material-block-price" :class="ColumnCssClass">
            <div class="shop__material-price-loading" v-show="PricesLoading">
                <div class="shop__material-price-loading-ani-container">
                    <div class="shop__material-price-loading-ani"></div>
                </div>
                {{Strings['Shop.PriceCalculating']}}
            </div>
            <div class="shop__material-price" v-show="showPrice">
                <div v-if="PricesAvailable">
                    <div class="shop__material-price-per-unit">{{UnitPrice|formatPrice}}<br/><span class="shop__material-price-unit">{{Strings['Shop.For100Liter']}}</span></div>
                    <div class="shop__material-price-total"><small>{{Strings['Shop.Total']}} {{TotalPrice|formatPrice}}</small><br/><span class="shop__material-total-tax">{{Strings['Shop.InclTax']}}</span></div>
                </div>
                <div v-if="!PricesAvailable" class="shop__material-price-unavailable">
                    {{Strings['Shop.ProductUnavailable']}}
                </div>
            </div>
        </div>
        <div class="shop__material-block-selection" :class="ColumnCssClass">
            <div class="migrol-form__checkbox migrol-form__checkbox--checkbox" v-show="IsPickable">
                <input type="checkbox" :checked="isSelected" readonly />
                <label>{{ChooseProductLabel}}</label>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { mapFilters } from '@/utils/vueFilters';
    import Transaction from '@/models/Transaction';

    export default {
        props: {
            material: Object,
            showPrice: {
                type: Boolean,
                default: false
            },
            isSelected: {
                type: Boolean,
                default: false
            },
            col: {
                type: Number,
                default: 1
            }
        },
        computed: {
            ...mapState([
                'Strings',
                'PricesLoading'
            ]),
            UnitPrice() {
                return this.material.getUnitPrice(null);
            },
            TotalPrice() {
                return this.material.getTotalPrice(null);
            },
            CurrentTransaction() {
                return Transaction.query().with('material').first();
            },
            PricesAvailable() {
                return this.UnitPrice != null && this.TotalPrice != null;
            },
            IsPickable() {
                return (!this.showPrice || this.PricesAvailable)/* && !this.isSelected*/;
            },
            ChooseProductLabel() {
                return this.isSelected ? this.Strings['Shop.ButtonChosenProduct'] : this.Strings['Shop.ButtonChooseProduct'];
            },
            ColumnCssClass() {
                return "shop__material-block-col-" + this.col;
            }
        },
        watch: {
            showPrice() {
                this.ensureSelectedProductHasPrices();
            },
            PricesAvailable() {
                this.ensureSelectedProductHasPrices();
            }
        },
        methods: {
            ...mapFilters([
                'migrolFormatText'
            ]),
            selectMaterial() {
                if (!this.IsPickable) {
                    return;
                }

                var value = this.material;
                this.$emit('input', value);
            },
            ensureSelectedProductHasPrices() {
                if (this.showPrice && this.isSelected && !this.PricesAvailable) {
                    //if new prices have been calculated, the material is selected but no prices are available anymore (e.g. Tessin), unselect material
                    Transaction.update({
                        id: this.CurrentTransaction.id,
                        material_id: null,
                        material: null
                    });
                }
            }
        },
        components: {
            
        }
    };
</script>